import React, { useEffect } from 'react';
import { Input, InputGroup, InputGroupText } from 'reactstrap';
import { observer } from 'mobx-react';
import chatStorage from '../../pages/Chat/chatStorage';

function EditableText({
  type, placeholder, id, onInput, value, label, emptyValueText, onSave, debug, opened, changed, ...props
}) {
  const onInputChanged = (e) => {
    const { value } = e.target;
    if (debug) console.log('CHANGED VALUE:', value, onSave);
    if (onInput) onInput(id, value);
  };
  const [isEditable, setEditable] = React.useState(false);
  useEffect(() => {
    setEditable(opened);
  }, [opened]);
  return (isEditable ? (
    <div className="form-group">
      {label && <label htmlFor={id}>{label}</label>}
      <InputGroup>
        <Input
          id={id}
          className="form-control"
          type={type}
          // placeholder={placeholder}
          onInput={onInputChanged}
          value={value}
          onBlur={() => {
            onSave(id, value)
              .then((r) => {
                // if (r) setEditable(false);
              });
          }}
          {...props}
        />
        {/* <InputGroupText onClick={() => { */}
        {/*  onSave(id, value) */}
        {/*    .then((r) => { */}
        {/*      if (r) setEditable(false); */}
        {/*    }); */}
        {/* }} */}
        {/* > */}
        {/*  <i className="fa fa-save" /> */}
        {/* </InputGroupText> */}
        {/* {!chatStorage.changedFields[id] && ( */}
        {/* <InputGroupText onClick={() => { */}
        {/*  setEditable(false); */}
        {/* }} */}
        {/* > */}
        {/*  <i className="fa fa-times" /> */}
        {/* </InputGroupText> */}
        {/* )} */}
      </InputGroup>
    </div>
  ) : (
    <div style={{ display: 'flex', flexDirection: 'row' }} onClick={() => setEditable(true)}>
      {label}
      :&nbsp;
      {value || emptyValueText}
      &nbsp;&nbsp;
      {/* <i className="fa fa-pencil" /> */}
    </div>
  )
  );
}

EditableText.defaultProps = {
  type: 'text',
  isEditable: false,
};
EditableText.propTypes = {};

export default observer(EditableText);
